var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 43,
    viewBox: "0 0 35 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.21 42.5744H3.77997C1.68997 42.5744 0 40.8744 0 38.7944V3.78439C0 1.69439 1.69997 0.00439453 3.77997 0.00439453H24.6C25.12 0.00439453 25.55 0.424395 25.55 0.954395C25.55 1.4844 25.13 1.90439 24.6 1.90439H3.77997C2.73997 1.90439 1.89001 2.7544 1.89001 3.7944V38.7944C1.89001 39.8344 2.73997 40.6844 3.77997 40.6844H31.21C32.25 40.6844 33.1 39.8344 33.1 38.7944V10.4144C33.1 9.89439 33.52 9.46439 34.05 9.46439C34.58 9.46439 35 9.88439 35 10.4144V38.7944C35 40.8844 33.3 42.5744 31.22 42.5744H31.21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0501 11.3544H24.5901C24.0701 11.3544 23.6401 10.9344 23.6401 10.4044V0.944444C23.6401 0.564444 23.8701 0.214445 24.2201 0.0744447C24.5701 -0.0755553 24.9801 0.00444376 25.2501 0.284444L34.7101 9.74444C34.9801 10.0144 35.0601 10.4244 34.9201 10.7744C34.7701 11.1244 34.4301 11.3544 34.0501 11.3544ZM25.5401 9.46444H31.7701L25.5401 3.23444V9.46444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAdd);
export default __webpack_public_path__ + "static/media/file_add.5668bd44173546c8c98ffefc49c686dc.svg";
export { ForwardRef as ReactComponent };